<!--
  (c) Copyright 2024 Calabrio, Inc.
  All Rights Reserved. www.calabrio.com LICENSED MATERIALS
  Property of Calabrio, Inc., Minnesota, USA

  No part of this publication may be reproduced, stored or transmitted,
  in any form or by any means (electronic, mechanical, photocopying,
  recording or otherwise) without prior written permission from Calabrio, Inc.
-->

<template>
  <div class="wy-configuration-target-experience-automation" v-loading="loading">
    <div class="title-btns-section"> 
      <div class="title">Experience & Automation Targets</div>
      <div class="update-btns">
        <!-- <div class="update-cancel-btn" @click="controller.appVue.handleAppModalClose">Cancel</div> -->
        <button :class="(isDisabled?'update-save-btn disabled':'update-save-btn')"  :disabled="isDisabled" @click="updateTarget">Update</button>
      </div>
    </div>
    <div class="btn-section">
      <div class="clear-all-btn" :class="{'disabled':disableClearAllBtn}" @click="handleClearAllTargets"><span>Clear all values</span></div>
    </div>
    <div class="title-description-content">Configure targets and industry benchmarks for the listed bot metrics.</div>
    <div class="content-section"> 
      <wy-table-list ref="targetDefaultTable" :controller="module" :tableDataResults="tableData" :tableColumns="tableColumns" :enableSelection="true" :mode="'generic'" />
    </div>
  </div>
</template>

<script>
  import { mapGetters, mapActions } from 'vuex';
  import WyTableList from '../../widgets/wy-bes_bas-default-targets';
  import WyAnalyticsUtils from '../../home/utils/wy-home-utils';

  export default {
    name: 'wy-configuration-target-experience-automation',
    components: {
      'wy-table-list': WyTableList,
    },
    props:  ['controller'],
    
    data() {
      return {
        module: this,
        loading: false,
        tableColumns: [
          {label: "bes target", name: "besTarget", type: "targetRange", mandatory: true, selected: false, sortable: true, hasSubtitle: false, group: 'BES Target', cssClass: 'bes-target', align:"center", minWidth: 300, fixed: false, copyable: false, isEditTopicName: false},
          {label: "bas target", name: "basTarget", type: "targetRange", mandatory: true, selected: false, sortable: true, hasSubtitle: false, group: 'BAS Target', cssClass: 'bas-target', align:"center", minWidth: 300, fixed: false, copyable: false, isEditTopicName: false}
        ],
        tableData: [],
        tableDataClone: [],
        defaultTargets: {},
        originCompanySettingData: null,
        disableClearAllBtn: false
      };
    },


    computed: {
      ...mapGetters(['dataModel', 'isRoleAllow', 'companyProfileSettings']),

      isDisabled() {
        return !this.controller.hasNoSavedChanges || this.controller.hasError;
      }
    },

    methods: {
      ...mapActions(['updateCompanyProfileSettings']),

      compareDifference(newValue, oldValue) {
        newValue.forEach(item => {
          if(item.besTarget.value=='') {
            item.besTarget.value = null
          }
          if(item.basTarget.value=='') {
            item.basTarget.value = null
          }
        })
        if(JSON.stringify(newValue) === JSON.stringify(oldValue)) {
          setTimeout(() => {
            this.controller.hasNoSavedChanges = false;
          }, 0)
        }
        else {
          setTimeout(() => {
            this.controller.hasNoSavedChanges = true;
          }, 0)
        }
      },

      handleDiscardUnsavedChanges() {
        this.controller.hasNoSavedChanges = false;
        this.controller.hasError = false;
        if(!this.originCompanySettingData || !this.originCompanySettingData.targetSettings) {
          this.companyProfileSettings.targetSettings = null
        }
        else {
          this.companyProfileSettings.targetSettings = this.originCompanySettingData.targetSettings
        }
        this.prepareData()
      },

      handleClearAllTargets() {
        this.controller.hasError = false;
        this.$refs.targetDefaultTable.removeTargetValue('besTarget',  this.$refs.targetDefaultTable.targetsData[0].besTarget)
        this.$refs.targetDefaultTable.removeTargetValue('basTarget',  this.$refs.targetDefaultTable.targetsData[0].basTarget)
        this.$refs.targetDefaultTable.removeTargetValue('acTarget',  this.$refs.targetDefaultTable.targetsData[0].acTarget)
        this.$refs.targetDefaultTable.removeTargetValue('besBenchmark',  this.$refs.targetDefaultTable.targetsData[0].besBenchmark)
        this.$refs.targetDefaultTable.removeTargetValue('basBenchmark',  this.$refs.targetDefaultTable.targetsData[0].basBenchmark)
        this.$refs.targetDefaultTable.removeTargetValue('acBenchmark',  this.$refs.targetDefaultTable.targetsData[0].acBenchmark)
      },

      prepareUpdateData(data) {
        let cloneData = JSON.parse(JSON.stringify(data))
        let updateData = {
          actived: false,
          target: {}
        }
        Object.keys(cloneData.target).forEach(key => {
          if(cloneData.target[key].minValue != undefined && cloneData.target[key].maxValue != undefined) {
            updateData.actived = true;
            if(cloneData.target[key].minValue == null) {
              // cloneData.target[key].minValue = cloneData.target[key].minValue;
            }
            else {
              cloneData.target[key].minValue = Number(cloneData.target[key].minValue);
            }
            if(cloneData.target[key].maxValue == null) {
              // cloneData.target[key].maxValue = cloneData.target[key].maxValue;
            }
            else {
              cloneData.target[key].maxValue = Number(cloneData.target[key].maxValue);
            }
            cloneData.target[key].minValue = Number(cloneData.target[key].minValue)
            cloneData.target[key].maxValue = Number(cloneData.target[key].maxValue)
            updateData.target[key] = cloneData.target[key];
          }
          else {
            updateData.actived = true;
            if(cloneData.target[key].value == null) {
              // cloneData.target[key].value = cloneData.target[key].value;
            }
            else {
              cloneData.target[key].value = Number(cloneData.target[key].value);
            }
            updateData.target[key] = cloneData.target[key];
          }
          if(key == 'bes' || key == 'bas' || key == 'ac') {
            if(Object.keys(cloneData.target[key]).includes('value')) {
              delete cloneData.target[key].value;
            }
          }
          if(key == 'acBenchmark' && cloneData.target[key].isNull) {
            cloneData.target[key].value = null;
            updateData.target[key] = cloneData.target[key];
          }
          if(key == 'ac' && cloneData.target[key].isNull) {
            cloneData.target[key].minValue = null;
            cloneData.target[key].maxValue = null;
            updateData.target[key] = cloneData.target[key];
          }
        })
        return updateData
      },

      async updateTarget() {
        if(this.defaultTargets.target.bes.maxValue && this.defaultTargets.target.bes.minValue || this.defaultTargets.target.bas.maxValue && this.defaultTargets.target.bas.minValue) {
          this.defaultTargets.actived = true
        }
        else {
          this.defaultTargets.actived = false
        }
        let updatedData = this.prepareUpdateData(this.defaultTargets)
        if(updatedData.actived) {
          if(!this.companyProfileSettings.targetSettings) {
            this.companyProfileSettings.targetSettings = {settings: {}};
          }
          if(!this.companyProfileSettings.targetSettings.settings.home) {
            this.companyProfileSettings.targetSettings.settings.home = {
              experienceAutomationSummary: {}
            }
          }
          this.companyProfileSettings.targetSettings.settings.home.experienceAutomationSummary.default = updatedData;
        }
        else {
          if(this.companyProfileSettings.targetSettings.settings.home.experienceAutomationSummary.default) {
            delete this.companyProfileSettings.targetSettings.settings.home.experienceAutomationSummary.default;
          }
        }
        
        this.loading = true;
        let companyProfileSettingsLocal = this.companyProfileSettings.targetSettings.settings;
        let success = await this.updateCompanyProfileSettings(companyProfileSettingsLocal);
        if(success) {
          this.loading = false;
          this.controller.hasNoSavedChanges = false;
          this.controller.isDashBoardModified = true;
          this.originCompanySettingData = JSON.parse(JSON.stringify(this.companyProfileSettings));
          this.tableDataClone = JSON.parse(JSON.stringify(this.tableData))
          this.$message({
            showClose: true,
            message: this.$t("configurations.targetUpdateSuccess"),
            customClass: 'configuration-success-message',
            duration: 5000,
            type: 'success'
          });
        }
        else {
          this.loading = false;
          this.$message({
            showClose: true,
            message: this.$t("configurations.targetUpdateFailed"),
            customClass: 'configuration-failed-message',
            duration: 5000,
            type: 'error'
          });
        }
      },

      updatedTargetList(target) {
        this.defaultTargets.target = {
          bes: target.besTarget,
          bas: target.basTarget,
          ac:  target.acTarget,
          besBenchmark:  target.besBenchmark,
          basBenchmark:  target.basBenchmark,
          acBenchmark:  target.acBenchmark,
        }
        this.compareDifference(this.tableData, this.tableDataClone)
      },

      handleSaveUnchanges(newTab, handleAppModalClose) {
        this.controller.$refs.updateDialog.title = `Review changes`;
        this.controller.$refs.updateDialog.content="There are unsaved changes. Do you want to discard or save them before leaving?" 
        this.controller.$refs.updateDialog.open();
        if(this.controller.hasError) {
          this.controller.$refs.updateDialog.disableSaveBtn = true;
        }
        else {
          this.controller.$refs.updateDialog.disableSaveBtn = false;
        }
        this.controller.$refs.updateDialog.confirmButtonCallback = async () => {
          this.updateTarget()
          this.controller.hasNoSavedChanges = false;
          if(handleAppModalClose) {
            handleAppModalClose();
          }
          else {
            this.controller.handleTabClick({name: newTab})
            this.controller.activeTab = newTab
          }
        }
        this.controller.$refs.updateDialog.discardButtonCallback = async () => {
          this.handleDiscardUnsavedChanges()
          if(handleAppModalClose) {
            handleAppModalClose();
          }
          else {
            this.controller.handleTabClick({name: newTab})
            this.controller.activeTab = newTab
          }
        }
      },

      prepareData() {
        this.defaultTargets = {
          actived: false,
          target: {}
        };
        Object.keys(WyAnalyticsUtils.configrationMapping).forEach(key => {
          this.defaultTargets.target[key] = {
            prefix: WyAnalyticsUtils.configrationMapping[key].prefix,
            suffix: WyAnalyticsUtils.configrationMapping[key].suffix
          }
        })
        let existingDefault = null;
        this.originCompanySettingData = JSON.parse(JSON.stringify(this.companyProfileSettings));
        if(this.companyProfileSettings && this.companyProfileSettings.targetSettings && this.companyProfileSettings.targetSettings.settings.home) {
          existingDefault = this.companyProfileSettings.targetSettings.settings.home.experienceAutomationSummary.default;
        }
        if(this.companyProfileSettings.targetSettings == null) {
          this.defaultTargets.target.ac = {
            "minValue": null,
            "maxValue": null,
            "prefix": "$",
            "suffix": ""
          }
          this.defaultTargets.target.bes = {
            "minValue": null,
            "maxValue": null,
            "prefix": "",
            "suffix": ""
          }
          this.defaultTargets.target.bas = {
            "minValue": null,
            "maxValue": null,
            "prefix": "",
            "suffix": "%"
          }
          this.defaultTargets.target.besBenchmark = {
            "value": null,
            "prefix": "",
            "suffix": ""
          }
          this.defaultTargets.target.basBenchmark = {
            "value": null,
            "prefix": "",
            "suffix": "%"
          }
          this.defaultTargets.target.acBenchmark = {
            "value": null,
            "prefix": "$",
            "suffix": ""
          }
        }
        if(this.companyProfileSettings && existingDefault && existingDefault.actived) {
          this.defaultTargets.actived = true;
          Object.keys(existingDefault.target).forEach(key => {
            this.defaultTargets.target[key] = existingDefault.target[key];
          })
          if(!Object.keys(existingDefault.target).includes('besBenchmark')) {
            this.defaultTargets.target.ac = {
              "minValue": null,
              "maxValue": null,
              "prefix": "$",
              "suffix": ""
            }
            this.defaultTargets.target.besBenchmark = {
              "value": null,
              "prefix": "",
              "suffix": ""
            }
            this.defaultTargets.target.basBenchmark = {
              "value": null,
              "prefix": "",
              "suffix": "%"
            }
            this.defaultTargets.target.acBenchmark = {
              "value": null,
              "prefix": "$",
              "suffix": ""
            }
          }
        }
        this.tableData = [];
        let target = this.defaultTargets.target;
        let obj = {};
        Object.keys(this.defaultTargets.target).forEach(key => {
          if(key == 'bes' || key == 'bas' || key == 'ac') {
            obj[key + 'Target'] = target[key];
            if(target[key] && target[key].value != undefined) {
              obj[key + 'Target'].value = target[key].value;
            }
            else {
              obj[key + 'Target'].minValue = target[key].minValue;
              obj[key + 'Target'].maxValue = target[key].maxValue;
            }
          }
          else {
            obj[key] = target[key];
            obj[key].minValue = target[key].minValue;
            obj[key].maxValue = target[key].maxValue;
          }
          if(key == 'acBenchmark' && obj[key].value == null) {
            obj[key].value = '';
            obj[key].isNull = true;
          }
          if(key == 'ac' && (obj[key + 'Target'].minValue == null || obj[key + 'Target'].maxValue == null)) {
            obj[key + 'Target'].minValue = '';
            obj[key + 'Target'].maxValue = '';
            obj[key + 'Target'].isNull = true;
          }
        })
        this.tableData.push(obj)
       
        this.tableDataClone = JSON.parse(JSON.stringify(this.tableData))
      }
      
    }
  };
</script>

<style lang="scss">
  .wy-configuration-target-experience-automation {
    min-width: 1065px;
    height: inherit;

    .content-section {
      height: inherit;
      .wy-genaric-table {
        height: inherit;
      }
    }
    .wy-genaric-table .wy-table-wrapper {
      border-radius: 0px !important;
      height: calc(100% - 75px);
      // padding-right: 10px;

      // &::-webkit-scrollbar {
      //   background-color: white !important;
      //   width: 10px !important;
      // }
      // &::-webkit-scrollbar-thumb{
      //   // background: #CAD2DA !important;
      //   background: #c5c5c7 !important;
      //   border-radius: 50px !important; 
      // } 
    }
    .wy-genaric-table .wy-table-fixed tbody tr td:first-child {
      background-color: #FFFF;
    }
    .wy-genaric-table .wy-table-main thead tr {
      width: 100%;
      width: calc(100vw - 372px);
    }
    .wy-table-main thead {
      background-color: #FFF;
      border: 1px solid #CAD2DA;
      width: calc(100vw - 372px);
    }
    .wy-table-main thead th {
      background-color: #FFF;
      text-align: left !important;
    }
    .wy-genaric-table .wy-table-main tbody {
      
      // height: calc( 100vh - 488px);
      height: calc( 100vh - 355px);
      overflow: hidden;
      width: calc(100vw - 372px);
      border-right: 1px solid #CAD2DA;
      border-left: 1px solid #CAD2DA;
      border-bottom: 1px solid #CAD2DA;
    }
    .wy-genaric-table tbody tr td {
      border-bottom: 0px solid #eee;
      div {
        // margin-left: 16px;
        justify-content: left;
      }
    }
    .title-btns-section {
      display: inline-flex;
      width: 100%;
      margin-bottom: 10px;
      .title {
        line-height: 2;
        font-size: 16px;
        font-weight: 700;
      }
      .update-btns {
        display: inline-flex;
        margin-left: auto;
      }
      .update-cancel-btn {
        color: #202223 !important;
        font-family: Helvetica Neue, Helvetica, Arial, sans-serif;
        font-size: 15px;
        font-weight: 400;
        padding: 8px 16px 8px 16px;
        display: flex;
        border-radius: 5px;
        height: fit-content;
        width: fit-content;
        border: 1px solid #CAD2DA;
        cursor: pointer;
        background: white;
        margin-right: 15px;
        align-items: center;
        justify-content: center;
        &:hover{
          background: #F4F6F8;
        }
      }
      .update-save-btn {
        width: fit-content;
        height: fit-content;
        padding: 8px 16px 8px 16px;
        font-size: 15px;
        cursor: pointer;
        background: var(--site-button-primary-btn-background-primary-color);
        color: var(--site-button-primary-btn-text-primary-color) !important;
        border: 1px solid var(--site-button-primary-btn-hover-border-primary-color);
        font-family: Helvetica Neue, Helvetica, Arial, sans-serif;
        border-radius: 5px;
        // margin-right: 15px;
        align-items: center;
        justify-content: center;
      }
      .update-save-btn:hover {
        border: 1px var(--site-button-primary-btn-hover-border-primary-color) solid !important;
        background-color: var(--site-button-primary-btn-hover-background-primary-color) !important;
        border-radius: 5px;
        color: var(--site-button-primary-btn-text-primary-color) !important;
      }
      .update-save-btn:active {
        background-color: var(--site-button-primary-btn-pressed-background-primary-color) !important;
      }
      .update-save-btn:focus {
        border: 1px var(--site-button-primary-btn-hover-border-primary-color) solid !important;
        border-radius: 5px;
        color: var(--site-button-primary-btn-text-primary-color) !important;
      }
      .update-save-btn.disabled {
        background: var(--site-button-primary-btn-disabled-background-primary-color);
        cursor: not-allowed;
      }
      .update-save-btn.disabled:hover {
        border: 1px var(--site-button-primary-btn-hover-border-primary-color) solid !important;
        background: var(--site-button-primary-btn-disabled-background-primary-color) !important;
        border-radius: 5px;
        color: var(--site-button-primary-btn-text-primary-color) !important;
      }
      .update-save-btn.disabled:active {
        background: var(--site-button-primary-btn-disabled-background-primary-color) !important;
      }
      .update-save-btn.disabled:focus {
        border: 1px var(--site-button-primary-btn-hover-border-primary-color) solid !important;
        border-radius: 5px;
        color: var(--site-button-primary-btn-text-primary-color) !important;
      }
      .intent-action-dropdown-save-btn:disabled{
        background: #C0C4CC;
        cursor: not-allowed;
      }
    }
    .btn-section {
      display: flex;
      float: right;
      // width: 425px;
      .clear-all-btn {
        font-size: 12px;
        width: 105px;
        text-align: right;
        line-height: 1;
        color: #106FBC;
        cursor: pointer;
      }
      .clear-all-btn.disabled{
        pointer-events: none;
        color: #CCC;
      }
      .reset-all-btn {
        font-size: 12px;
        width: 142px;
        line-height: 1;
        color: #106FBC;
        cursor: pointer;
      }
    }
    .title-description-content {
      font-size: 14px;
      font-weight: 400;
      padding-bottom: 30px;
    }
    // .el-loading-mask {
    //   height: calc(100vh - 400px);
    // }
  }
  .configuration-success-message {
    background-color: #D9EEDF;
    border-color: #86D2AE;
    .el-icon-success {
      color: #186731;
    }
    .el-message__content {
      color: var(--site-font-secondary-color);
    }
  }
</style>